module.exports = __webpack_public_path__ + "img/img16.2c930b8e.svg";